import { apiSlice } from "../../../services";
import { IGetListRequest, IGetListResponse, IGetProjectPhotosRes, IGetResponse } from "../../../types/interfaces";
import { isDev } from "../../../utils";
import {
    ICreateProjectReq,
    ICreateProjectRes,
    IDeleteProjectReq,
    IDownloadExcelReq,
    IDownloadExcelRes,
    IDownloadPictureReq,
    IDownloadPictureRes,
    IExportUsageReportRes,
    IGetProjectPhotosReq,
    IInitProjectReq,
    IProjectApiResponse,
    IProjectTypes,
    IQueryProjectParams,
    IUpdateProjectReq,
} from "../types/interfaces";

const DOWNLOAD_API_URL = import.meta.env.VITE_DOWNLOAD_PROJECT_RECORDS_URL;
const Mock_API_URL = "https://dashboard.ai-amaze.com/api/download_photo";
export const projectsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        initFirstProject: builder.mutation<ICreateProjectRes, IInitProjectReq>({
            // create new user gift
            query: (reqData) => ({
                url: "/init_project",
                method: "POST",
                body: { ...reqData },
                //timeout: 1000 * 60 * 10,
            }),
            invalidatesTags: ["Project"],
        }),
        createProject: builder.mutation<{ success: boolean; projects: string }, ICreateProjectReq>({
            query: (reqData) => ({
                url: "/create_project",
                method: "POST",
                body: { ...reqData },
            }),
            invalidatesTags: ["Project"],
        }),
        updateProject: builder.mutation<{ success: boolean; projects: string }, IUpdateProjectReq>({
            query: (reqData) => ({
                url: "/project/update_record",
                method: "POST",
                body: { ...reqData },
            }),
            invalidatesTags: ["Project"],
        }),
        deleteProject: builder.mutation<{ success: boolean }, IDeleteProjectReq>({
            query: (reqData) => ({
                url: "/project/delete_project",
                method: "DELETE",
                body: { ...reqData },
            }),
            invalidatesTags: ["Project"],
        }),
        getAllProjects: builder.query<IGetListResponse<IProjectTypes[]>, IGetListRequest>({
            query: (reqData) => ({
                url: "/project/list_records",
                method: "POST",
                body: { ...reqData },
            }),
            providesTags: ["Project"],
        }),
        getProject: builder.query<IGetResponse<IProjectTypes>, IQueryProjectParams>({
            query: (params) => ({
                url: "/project/get_record",
                params,
            }),
            transformResponse: (response: IProjectApiResponse<IProjectTypes>) => {
                return {
                    status: response.status,
                    message_key: response.message_key,
                    message: response.message,
                    request: "",
                    data: response.data.data,
                };
            },
            providesTags: ["Project"],
        }),
        getProjectPhotos: builder.query<IGetProjectPhotosRes, IGetProjectPhotosReq>({
            query: (reqData) => ({
                url: `/project/photos`,
                method: "POST",
                body: { ...reqData },
            }),
        }),
        downloadPicture: builder.mutation<IDownloadPictureRes, IDownloadPictureReq>({
            query: (reqData) => ({
                url: isDev ? Mock_API_URL : `${DOWNLOAD_API_URL}/download_photo`,
                method: "POST",
                body: { ...reqData },
            }),
        }),
        downloadExcel: builder.mutation<IDownloadExcelRes, IDownloadExcelReq>({
            query: (reqData) => ({
                url: "/project/export_usage_report",
                method: "POST",
                body: { ...reqData },
            }),
            transformResponse: (response: IExportUsageReportRes) => response.data,
        }),
    }),
});

export const {
    useInitFirstProjectMutation,
    useGetAllProjectsQuery,
    useCreateProjectMutation,
    useDeleteProjectMutation,
    useGetProjectQuery,
    useUpdateProjectMutation,
    useDownloadPictureMutation,
    useDownloadExcelMutation,
    useGetProjectPhotosQuery,
} = projectsApiSlice;
